import User, { EUserStep } from "@api/models/User";
import useAppTranslation from "@hooks/language/useAppTranslation";
import useUserStore from "@store/user.store";
import { Trans } from "react-i18next";
import SSProgress from "./Progress";
import ContainerCard, {
  type IContainerCardProps,
} from "./container/ContainerCard";
import ContainerText from "./container/ContainerText";

interface IActualUserStepProps {
  containerProps?: IContainerCardProps;
  coinAmount?: number;
}

const CurrentStepProgressCard: React.FC<IActualUserStepProps> = ({
  containerProps,
  coinAmount,
}) => {
  const { affiliationInformation } = useUserStore();
  const user = new User(
    coinAmount ?? affiliationInformation?.totalAmountBoughtInEuros ?? 80,
  );

  const { t } = useAppTranslation("pages.clientDashboard.components");

  return (
    <ContainerCard
      title={t("currentStepProgressCard.title")}
      {...containerProps}
    >
      <SSProgress
        value={user.stepInfo.stepEuros}
        maximum={user.stepInfo.stepEurosLimit}
        variant={user.stepInfo.nextStepColor}
      />
      <ContainerText>
        {user.stepInfo.currentStep === EUserStep.MASTER ? (
          t("currentStepProgressCard.masterText")
        ) : (
          <Trans
            i18nKey="pages.clientDashboard.components.currentStepProgressCard.notMasterText"
            values={{
              amount: Math.round(user.stepInfo.stepEurosLeft),
              nextStep: user.stepInfo.nextStepColor,
              ordersLeft: user.stepInfo.ordersLeftLabel,
            }}
            components={{
              1: (
                <span
                  className={`font-bold ${user.stepInfo.nextStepTextClasses}`}
                />
              ),
              3: (
                <span
                  className={`font-bold capitalize ${user.stepInfo.nextStepTextClasses}`}
                />
              ),
            }}
          />
        )}
      </ContainerText>
    </ContainerCard>
  );
};

export default CurrentStepProgressCard;
